var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 23,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74008 3.8773L3.07907 7.21647C2.89543 7.44691 3.05213 7.79677 3.33898 7.79677L8.66102 7.79677C8.94787 7.79677 9.10457 7.44691 8.92093 7.21647L6.25992 3.8773C6.12465 3.70757 5.87535 3.70757 5.74008 3.8773Z",
    fill: "#A1B1CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25992 19.6696L8.92093 16.3304C9.10457 16.1 8.94787 15.7501 8.66102 15.7501L3.33898 15.7501C3.05213 15.7501 2.89543 16.1 3.07907 16.3304L5.74008 19.6696C5.87535 19.8393 6.12465 19.8393 6.25992 19.6696Z",
    fill: "#A1B1CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 23,
    rx: 1.5,
    stroke: "#DEE2EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.7b86969d551fd5725f38b4b8d86a403f.svg";
export { ForwardRef as ReactComponent };